import parsePhoneNumber from "libphonenumber-js";

export const formatPhoneNumber = (phone) => {
  return phone ? parsePhoneNumber(phone, "US").formatNational() : phone;
};
